const env_set = 1 // 1: production, 2: staging

const baseURL = env_set == 2 ? process.env.REACT_APP_BACKEND_URL : process.env.REACT_APP_BACKEND_URL_PROD;

const selfcareURL = env_set == 2 ? process.env.REACT_APP_SELFCARE_URL : process.env.REACT_APP_SELFCARE_URL_PROD;

export const BACKEND_API = `${baseURL}/mapi/services`;
export const PAY_MONEY_API = `${baseURL}/VNPTPay/topup_2.0.0.jsp?sandbox=release`;
export const PAY_BILL_API = `${baseURL}/VNPTPay/pay_1.0.6.jsp?sandbox=release`;
export const PAY_API = `${baseURL}/pay`;

export const SELFCARE = `${selfcareURL}`;
// export const SELFCARE = `${baseURL}/doanh-nghiep`;

export const URL_LOGIN_3G = 'http://auth-myvnpt.vnpt.vn';
export const YOUR_API_KEY = 'AIzaSyDnXwhhg8SfyNqOzPcFJvW3NywvXoRPRww';

//pay
// const payURL = 'https://sandboxpay.vnptmedia.vn/webview-portal'; //sandbox
// const payURL = 'https://congdichvulive2.vnptmoney.vn'; //live2
const payURL = 'https://congdichvu.vnptmoney.vn'; //live
export const PAY_PORTAL = `${payURL}/services/`

// key_landing_page
// token = SHA256(msisdn+"|"+request_id+"|"+partner_code+"|"+SECRET_KEY)
export const  SECRET_KEY = "6633e56f055a80a94ca621797874c137";
